exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a ion-icon[data-v-ae786bd4]{position:relative;right:5px}", ""]);

// exports
